import { toRefs, reactive } from 'vue'
import { Message } from 'view-design'
import { PLATFORM } from '../consts/index.js'
import { addPopularGame } from '@/api/track.plan.model'

/**
 * @description: 常用游戏管理弹窗
 * @return {*}
 */
export const useAddPoPularGameModal = (getTableData) => {
  const configModel = reactive({
    isEdit: false,
    showAddFormModal: false,
    addConfigRef: null,
    addConfigSubmitLoading: false,
    addPoPularGameSubmitLoading: false
  })

  function showAddConfigModal(row) {
    if (row) {
      const { platform, productId, gameAddress, channelAdjustStatus, iosMoneyAdjust, androidMoneyAdjust } = row
      configModel.addConfigRef.setFormValue({
        platform,
        gameId: productId,
        gameAddress,
        channelAdjustStatus,
        iosMoneyAdjust: (iosMoneyAdjust * 100).toFixed(2),
        androidMoneyAdjust: (androidMoneyAdjust * 100).toFixed(2)
      })
      configModel.isEdit = true
    } else {
      configModel.isEdit = false
    }
    configModel.showAddFormModal = true
  }

  const onPopularGameConfigSubmit = () => {
    const { platform, androidMoneyAdjust, iosMoneyAdjust, ...restValue } = configModel.addConfigRef.getFormValue()
    const params = {
      ...restValue,
      platform
    }

    if (platform === PLATFORM.MINIPROGRAM) {
      params.androidMoneyAdjust = (androidMoneyAdjust / 100).toFixed(4)
      params.iosMoneyAdjust = (iosMoneyAdjust / 100).toFixed(4)
    }

    configModel.addConfigSubmitLoading = true
    addPopularGame(params).then((data) => {
      if (data) {
        Message.success('修改成功')
        getTableData()
        configModel.showAddFormModal = false
      }
    }).finally(() => {
      configModel.addConfigSubmitLoading = false
    })

    console.log('paramsparamsparams output: ', params)
  }

  return {
    ...toRefs(configModel),
    showAddConfigModal,
    onPopularGameConfigSubmit
  }
}
